import { z } from "zod";

export const BudgetSchema = z.object({
  budgetId: z.string(),
  budgetName: z.string(),
  linearNumbering: z.boolean(),
  standardCostType: z.boolean(),
  columns: z.number().nullable(),
  columnOrder: z.array(z.number()),
});

export const BudgetItemSchema = z.object({
  budgetItemId: z.string(),
  budgetId: z.string(),
  ordinal: z.number(),
  lineRef: z.string(),
  description: z.string(),
  costType: z.string(),
  custCostType: z.string(),
  budgetAmount: z.number(),
  percentBudget: z.number(),
  flags: z.number(),
});

export const BudgetListSchema = z.array(BudgetSchema);
export const BudgetItemListSchema = z.array(BudgetItemSchema);

export type Budget = z.infer<typeof BudgetSchema>;
export type BudgetItem = z.infer<typeof BudgetItemSchema>;
